import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const mangoConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Mango FL Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Mango, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_mango_fl',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Mango, FL',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Mango FL Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide expert tree care to the 
     established neighborhoods of <strong>Mango, FL</strong>. This East Hillsborough 
     community between Brandon and Seffner features mature residential streets with 
     large trees that have grown close to homes, carports, and power lines over the 
     years. Florida's annual storm season makes managing those trees proactively 
     essential and our team handles the difficult jobs with skill.`,

    `We specialize in <strong>hazardous tree removal and targeted trimming</strong> 
     overhanging limbs near structures, storm weakened trunks, dense canopy growth 
     that increases wind load risk, and full tree removals on tight residential lots. 
     We assess every situation on site and execute safely from start to finish.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, affordable tree care 
     throughout <strong>Mango</strong> and the surrounding 
     <strong>East Hillsborough</strong> communities protecting your property 
     and keeping your trees in great shape all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Mango, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Mango = () => <LocationPage config={mangoConfig} />;
export default Services_Mango;
